var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout layout--default",class:_vm.isImpersonating ? 'layout--impersonating' : ''},[_c('Navigation',{staticClass:"layout__navigation"}),_c('main',{staticClass:"layout__main"},[_vm._t("default"),_c('FooterBar',{staticClass:"layout__footer"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }